import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * Big, friendly tappable calculator tile.
 * Used on Landing + Dashboard so a new visitor sees calculators front-and-centre.
 *
 * Mobile: horizontal row (icon | name+sub | arrow) — full width, easy thumb target
 * Desktop: vertical card (icon top, name + sub below)
 */
export default function CalculatorTile({
  to,
  icon: Icon,
  title,
  sub,
  testId,
  emphasised = false,
  external = false,
}) {
  const commonClass = `group relative flex items-center md:flex-col md:items-start md:text-left gap-4 md:gap-3 p-5 md:p-6 border border-[var(--border)] hover:border-[var(--primary)] active:border-[var(--primary)] hover:bg-[var(--surface-2)] active:bg-[var(--surface-2)] transition-colors min-h-[88px] ${
    emphasised ? "bg-[var(--surface)]" : "bg-[var(--surface)]/60"
  }`;
  const inner = (
    <>
      <div className="shrink-0 w-12 h-12 md:w-14 md:h-14 bg-[var(--primary)]/10 border border-[var(--primary)]/30 flex items-center justify-center group-hover:bg-[var(--primary)]/20">
        <Icon
          size={24}
          strokeWidth={1.75}
          className="text-[var(--primary)] group-hover:scale-110 transition-transform"
        />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-display text-lg md:text-xl tracking-tight">{title}</div>
        <div className="text-[11px] md:text-xs font-mono text-zinc-400 mt-0.5 md:mt-1 uppercase tracking-wider truncate">
          {sub}
        </div>
      </div>
      <ArrowRight
        size={18}
        className="shrink-0 text-zinc-500 group-hover:text-[var(--primary)] md:hidden"
      />
    </>
  );
  const testid = testId || `calc-tile-${title.toLowerCase().replace(/[^a-z]/g, "")}`;
  if (external) {
    return (
      <a
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testid}
        className={commonClass}
      >
        {inner}
      </a>
    );
  }
  return (
    <Link to={to} data-testid={testid} className={commonClass}>
      {inner}
    </Link>
  );
}
